module.exports = __webpack_public_path__ + "static/media/mailbox.cca8efb6.svg";